// extracted by mini-css-extract-plugin
export default {"custom-select":"SelectProduct_custom-select__QaJMA","header-select":"SelectProduct_header-select__5OBI0"};